<div class="calls-container" [class.modal-view]="isModal()">
  <!-- Call History -->
  <div class="calls-list" *ngIf="!isLoadingHistory && calls.length > 0">
    <!-- Call Cards -->
    <div class="call-card" *ngFor="let call of calls; trackBy: trackById"
         [class.recent]="isRecentCall(call.start_time)">
      
      <!-- Direction Indicator -->
      <div class="call-direction" [class.inbound]="call.direction === 'INBOUND'" 
           [class.outbound]="call.direction !== 'INBOUND'">
        <mat-icon>{{ getDirectionIcon(call.direction) }}</mat-icon>
      </div>

      <!-- Main Content -->
      <div class="call-content">
        <!-- Top Row: Phone & Time -->
        <div class="call-header">
          <span class="phone-number">
            {{ call.direction === 'INBOUND' ? call.caller_phone_number : call.recipient_phone_number }}
          </span>
          <span class="call-time">{{ call.start_time | customDate }}</span>
        </div>

        <!-- Bottom Row: Stats -->
        <div class="call-meta">
          <div class="meta-item" matTooltip="Duration">
            <mat-icon>schedule</mat-icon>
            <span>{{ formatDuration(call.duration) }}</span>
          </div>
          
          <div class="meta-item" *ngIf="formatWaitTime(call) !== '-'" 
               [matTooltip]="call.direction === 'INBOUND' ? 'Queue + Ring time' : 'Ring time'">
            <mat-icon>hourglass_empty</mat-icon>
            <span>{{ formatWaitTime(call) }}</span>
          </div>

          <div class="meta-item agent" *ngIf="getAgentName(call) !== '-'" [matTooltip]="call.user?.email || ''">
            <mat-icon>person</mat-icon>
            <span>{{ getAgentName(call) }}</span>
          </div>
        </div>
      </div>

      <!-- Status Column -->
      <div class="call-status-col">
        <span class="status-chip" [attr.data-status]="call.call_status">
          <span class="status-dot"></span>
          {{ call.call_status | lowercase }}
        </span>
        <span class="disposition-chip" *ngIf="call.disposition">
          {{ call.disposition.name }}
        </span>
      </div>

      <!-- Actions -->
      <div class="call-actions" *ngIf="hasRecording(call)">
        <button class="action-btn play" (click)="playRecording(call)" matTooltip="Play Recording">
          <mat-icon>play_arrow</mat-icon>
        </button>
        <button class="action-btn download" (click)="downloadRecording(call)" matTooltip="Download">
          <mat-icon>download</mat-icon>
        </button>
      </div>
      <div class="call-actions placeholder" *ngIf="!hasRecording(call)"></div>
    </div>

    <!-- Load More -->
    <button class="load-more-btn" *ngIf="showLoadMore" (click)="loadMoreCalls()" [disabled]="isLoadingMore">
      <mat-spinner *ngIf="isLoadingMore" diameter="18"></mat-spinner>
      <span *ngIf="!isLoadingMore">Load More Calls</span>
      <span *ngIf="isLoadingMore">Loading...</span>
    </button>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!isLoadingHistory && calls.length === 0">
    <div class="empty-icon">
      <mat-icon>phone_disabled</mat-icon>
    </div>
    <p class="empty-title">No call history</p>
    <p class="empty-subtitle">Calls with this lead will appear here</p>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoadingHistory">
    <mat-spinner diameter="32"></mat-spinner>
    <p>Loading calls...</p>
  </div>
</div>